// vim: ft=javascriptreact
import { useState } from 'react'
import {
  Row,
  Col,
  Button,
  Form,
  Alert,
  Spinner,
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import useAuth from '../hooks/useAuth'

const SignUpForm = () => {
  const navigate = useNavigate()

  const {
    signUp,
    email,
    setEmail,
    password,
    setPassword,
    authError,

    firstName,
    setFirstName,
    lastName,
    setLastName,
    phone,
    setPhone,
    unit,
    setUnitNumber,
    hasPadSetUp,
    setHasPadSetUp,
  } = useAuth()
  const [passwordConfirm, setPasswordConfirm] = useState('')

  const [signingUp, setSigningUp] = useState(false)

  const canSignUp = (!!firstName && !! lastName && !!email && !!phone && !!unit && !!password && !!passwordConfirm && (password === passwordConfirm))

  const isValidEmail = email && (email.length >= 5) && (/^.+@.+\..+$/.test(email))
  const isValidPhone = phone.replace(/[^0-9]/g, '').length >= 10
  const isValidUnit = /^[0-9]{1,2}$/.test(unit) && (unit.length === 1 || unit.length === 2)

  const onSignUp = async () => {
    setSigningUp(true)
    const result = await signUp({ email, password, firstName, lastName })

    setSigningUp(false)

    if (!result.userConfirmed) {
      window.localStorage.setItem('email', email)
      navigate('/auth/sign-up-confirm')
    }
  }

  if (signingUp) {
    return (
      <Spinner animation="border" role="status" variant="dark">
        <span className="visually-hidden">Signing Up...</span>
      </Spinner>
    )
  }

  return (
    <Form noValidate validated={canSignUp && isValidPhone && isValidUnit}>
      {authError && <Alert variant="danger">{authError}</Alert>}

      <Form.Group className="mb-3" controlId="email">
        <Form.Label>Email Address</Form.Label>
        <Form.Control
          type="email"
          placeholder="resident-only@theimperialstrata.com"
          value={email}
          isValid={isValidEmail}
          onChange={(e) => setEmail(e.target.value)} />
      </Form.Group>

      <Row>
        <Col sm="6">
          <Form.Group className="mb-3" controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <Form.Text>Must be at least 8 characters and contain upper and lower case letters as well as a number.</Form.Text>
          </Form.Group>

        </Col>
        <Col sm="6">
          <Form.Group className="mb-3" controlId="password-confirm">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control type="password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm="6">
          <Form.Group controlId="first-name" className="mb-3">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              value={firstName}
              isValid={!!firstName}
              onChange={(e) => setFirstName(e.target.value)} />
          </Form.Group>

        </Col>
        <Col sm="6">
          <Form.Group controlId="last-name" className="mb-3">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              value={lastName}
              isValid={!!lastName}
              onChange={(e) => setLastName(e.target.value)} />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm="6">
          <Form.Group controlId="phone" className="mb-3">
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="phone"
              value={phone}
              isValid={phone && isValidPhone}
              onChange={(e) => setPhone(e.target.value)} />
            <Form.Text>Used for account recovery, communication about your bookings, and accessing the amenities building.</Form.Text>
          </Form.Group>
        </Col>
        <Col sm="6">
          <Form.Group controlId="unit" className="mb-3">
            <Form.Label>Unit Number</Form.Label>
            <Form.Control
              type="number"
              placeholder="e.g. 99"
              required
              value={unit}
              className="w-25"
              isValid={unit && isValidUnit}
              onChange={(e) => setUnitNumber(e.target.value.replace(/[^0-9]/g, ''))} />
            <Form.Control.Feedback type="invalid">Invalid Unit</Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          id="agree-to-terms"
          label="I have already set up pre-authorized debit (PAD) with Davin Management"
          checked={hasPadSetUp}
          onChange={({ target }) => setHasPadSetUp(target.checked)}
        />
        {!hasPadSetUp && (
          <Form.Text className="text-danger">
            Bookings will not be confirmed until PAD has been set up.
          </Form.Text>
        )}
      </Form.Group>

      <Button variant="primary" size="lg" className="me-3" disabled={!canSignUp} onClick={onSignUp}>Sign Up</Button>
    </Form>
  )

}

export default SignUpForm

